/* eslint-disable import/prefer-default-export */
import { gatewayAxios, transactionsAxios } from 'util/Api';
import moment from 'moment';
import {
  FETCH_DUPLICATE_TRANSACTIONS_INIT,
  FETCH_DUPLICATE_TRANSACTIONS_SUCCESS,
  FETCH_DUPLICATE_TRANSACTIONS_ERROR,
  FETCH_MERCHANT_TRANSACTIONS_INIT,
  FETCH_MERCHANT_TRANSACTIONS_SUCCESS,
  FETCH_MERCHANT_RECENT_TRANSACTIONS_SUCCESS,
  FETCH_MERCHANT_TRANSACTIONS_ERROR,
  FETCH_SETTLEMENTS_INIT,
  FETCH_SETTLEMENTS_SUCCESS,
  FETCH_SETTLEMENTS_ERROR,
  APPROVE_SETTLEMENTS_INIT,
  APPROVE_SETTLEMENTS_SUCCESS,
  APPROVE_SETTLEMENTS_ERROR,
  SHOW_ERROR_MESSAGE,
  SHOW_MESSAGE,
  DOWNLOAD_SETTLEMENTS_INIT,
  DOWNLOAD_SETTLEMENTS_SUCCESS,
  DOWNLOAD_SETTLEMENTS_ERROR,
  DOWNLOAD_TRANSACTIONS_INIT,
  DOWNLOAD_TRANSACTIONS_SUCCESS,
  DOWNLOAD_TRANSACTIONS_ERROR,
  FETCH_TRANSACTIONS_INIT,
  FETCH_TRANSACTIONS_SUCCESS,
  FETCH_TRANSACTIONS_ERROR,
  FETCH_TRANSACTION_SUMMARY_INIT,
  FETCH_TRANSACTION_SUMMARY_VOLUME_SUCCESS,
  FETCH_TRANSACTION_SUMMARY_VOLUME_FAILED,
  FETCH_TRANSACTION_SUMMARY_VOLUME_ALL,
  FETCH_TRANSACTION_SUMMARY_VOLUME_TODAY,
  FETCH_TRANSACTION_SUMMARY_VOLUME_YESTERDAY,
  FETCH_TRANSACTION_SUMMARY_VOLUME_THIS_MONTH,
  FETCH_TRANSACTION_SUMMARY_VOLUME_LAST_MONTH,
  FETCH_TRANSACTION_SUMMARY_ERROR,
  DOWNLOAD_SUMMARY_INIT,
  DOWNLOAD_SUMMARY_SUCCESS,
  DOWNLOAD_SUMMARY_ERROR,
  SET_TRANSACTIONS_PAGE_SIZE,
  CHECK_TRANSACTION_STATUS_INIT,
  CHECK_TRANSACTION_STATUS_SUCCESS,
  CHECK_TRANSACTION_STATUS_ERROR,
  TRIGGER_WEBHOOK_INIT,
  TRIGGER_WEBHOOK_SUCCESS,
  TRIGGER_WEBHOOK_ERROR,
} from '../../constants/ActionTypes';
import { downloadExcel, downloadPDF, downloadReport } from '../../util/download';
import { TransactionStatuses } from '../../constants/System';

export const setTransactionsPageSize = (limit) => (dispatch) => {
  dispatch({ type: SET_TRANSACTIONS_PAGE_SIZE, limit });
};

export const createChargeBack = (data) => (dispatch) => {
  transactionsAxios.post('charge-back', data).then((axiosResponse) => {
    const response = axiosResponse?.data;
    dispatch({ type: SHOW_MESSAGE, payload: 'Succesfully created Chargeback', code: response?.code });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: "Ops!, We're having trouble creating this" });
    }
    console.error('Error: ', error.message);
  });
};

export const checkTransactionStatus = (serviceType, kitegatewayReference) => (dispatch) => {
  dispatch({ type: CHECK_TRANSACTION_STATUS_INIT });
  gatewayAxios.get(`check-status-and-update-transaction/${serviceType}/${kitegatewayReference}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    dispatch({ type: CHECK_TRANSACTION_STATUS_SUCCESS, payload: response?.data });
    dispatch({ type: SHOW_MESSAGE, payload: response?.message });
  }).catch((error) => {
    dispatch({ type: CHECK_TRANSACTION_STATUS_ERROR, paload: error });
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message || "Ops!, We're having trouble updating this" });
    } else if (error.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.message || "Ops!, We're having trouble updating this" });
    }
    console.error('Error: ', error.message);
  });
};

export const triggerWebhook = (kitegatewayReference) => (dispatch) => {
  dispatch({ type: TRIGGER_WEBHOOK_INIT });
  transactionsAxios.get(`backend-send-callback/${kitegatewayReference}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    dispatch({ type: TRIGGER_WEBHOOK_SUCCESS, payload: response?.data });
    dispatch({ type: SHOW_MESSAGE, payload: response?.message });
  }).catch((error) => {
    dispatch({ type: TRIGGER_WEBHOOK_ERROR, paload: error });
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message || "Ops!, We're having trouble updating this" });
    } else if (error.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.message || "Ops!, We're having trouble updating this" });
    }
    console.error('Error: ', error.message);
  });
};

export const updateChargebackStatus = (update) => (dispatch) => {
  transactionsAxios.put('charge-back/updateStatus', update).then((axiosResponse) => {
    const response = axiosResponse?.data;
    dispatch({ type: SHOW_MESSAGE, payload: response?.message || 'Succesfully Updated', code: response?.code });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message || "Ops!, We're having trouble updating this" });
    } else if (error.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.message || "Ops!, We're having trouble updating this" });
    }
    console.error('Error: ', error.message);
  });
};

export const updateRefundStatus = (update) => (dispatch) => {
  transactionsAxios.put('refunds/updateStatus', update).then((axiosResponse) => {
    const response = axiosResponse?.data;
    dispatch({ type: SHOW_MESSAGE, payload: response?.message || 'Succesfully Updated', code: response?.code });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message || "Ops!, We're having trouble updating this" });
    } else if (error.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.message || "Ops!, We're having trouble updating this" });
    }
    console.error('Error: ', error.message);
  });
};

export const updateSettlementStatus = (update) => (dispatch) => {
  transactionsAxios.put('settlements/updateStatus', update).then((axiosResponse) => {
    const response = axiosResponse?.data;
    dispatch({ type: SHOW_MESSAGE, payload: response?.message || 'Succesfully Updated', code: response?.code });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message || "Ops!, We're having trouble updating this" });
    } else if (error.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.message || "Ops!, We're having trouble updating this" });
    }
    console.error('Error: ', error.message);
  });
};

export const createSettlement = (data) => (dispatch) => {
  transactionsAxios.post('settlements', data).then((axiosResponse) => {
    const response = axiosResponse?.data;
    dispatch({ type: SHOW_MESSAGE, payload: response?.message || 'Succesfully Created', code: response?.code });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message || "Ops!, We're having trouble with this" });
    } else if (error.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.message || "Ops!, We're having trouble with this" });
    }
    console.error('Error: ', error.message);
  });
};

export const createWithdrawal = (data) => (dispatch) => {
  transactionsAxios.post('withdrawals', data).then((axiosResponse) => {
    const response = axiosResponse?.data;
    dispatch({ type: SHOW_MESSAGE, payload: response?.message || 'Succesfully Created', code: response?.code });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message || "Ops!, We're having trouble with this" });
    } else if (error.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.message || "Ops!, We're having trouble with this" });
    }
    console.error('Error: ', error.message);
  });
};

export const createDeposit = (data) => (dispatch) => {
  transactionsAxios.post('deposits', data).then((axiosResponse) => {
    const response = axiosResponse?.data;
    dispatch({ type: SHOW_MESSAGE, payload: response?.message || 'Succesfully Created', code: response?.code });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message || "Ops!, We're having trouble with this" });
    } else if (error.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.message || "Ops!, We're having trouble with this" });
    }
    console.error('Error: ', error.message);
  });
};

export const getMerchantTransactions = (merchantId, params = '', recent = false) => (dispatch) => {
  dispatch({ type: FETCH_MERCHANT_TRANSACTIONS_INIT });
  transactionsAxios.get(`merchant/${merchantId}${params ? `?${params}` : ''}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const headers = axiosResponse.headers['content-range'];
    let currentPage = 1;
    let totalRecords = 10;
    if (headers) {
      currentPage = Number(headers.split('-')[0]);
      totalRecords = Number(headers.split('/')[1]);
    }
    const payload = { data: response.data, currentPage, totalRecords };
    if (recent) {
      dispatch({ type: FETCH_MERCHANT_RECENT_TRANSACTIONS_SUCCESS, payload });
    } else {
      dispatch({ type: FETCH_MERCHANT_TRANSACTIONS_SUCCESS, payload });
    }
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: FETCH_MERCHANT_TRANSACTIONS_ERROR });
  });
};

export const getDuplicateTransactions = () => (dispatch) => {
  dispatch({ type: FETCH_DUPLICATE_TRANSACTIONS_INIT });
  transactionsAxios.get('duplicate/txns').then((axiosResponse) => {
    const response = axiosResponse?.data;
    dispatch({ type: FETCH_DUPLICATE_TRANSACTIONS_SUCCESS, payload: response.data });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: FETCH_DUPLICATE_TRANSACTIONS_ERROR });
    console.error(error);
  });
};

export const reverseDuplicateTransaction = (id) => (dispatch) => {
  transactionsAxios.post(`duplicate/reverse/${id}`, { force: false }).then((axiosResponse) => {
    const response = axiosResponse?.data;
    dispatch({ type: SHOW_MESSAGE, payload: response?.message || 'Succesfully done', code: response?.code });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message || "Ops!, We're having trouble with this" });
    } else if (error.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.message || "Ops!, We're having trouble with this" });
    }
    console.error('Error: ', error.message);
  });
};


export const fetchSettlements = (merchantId = null, params = '') => (dispatch) => {
  dispatch({ type: FETCH_SETTLEMENTS_INIT });
  const url = merchantId ? `/merchantSettlements/merchant/${merchantId}` : '/merchantSettlements';
  transactionsAxios.get(`${url}${params ? `?${params}` : ''}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const currentPage = Number(axiosResponse.headers['content-range'].split('-')[0]);
    const totalRecords = Number(axiosResponse.headers['content-range'].split('/')[1]);
    const payload = { data: response.data, totalRecords, currentPage };
    dispatch({ type: FETCH_SETTLEMENTS_SUCCESS, payload });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: FETCH_SETTLEMENTS_ERROR });
    console.error(error);
  });
};

export const approveSettlement = (id, data) => (dispatch) => {
  dispatch({ type: APPROVE_SETTLEMENTS_INIT });
  transactionsAxios.post(`/merchantSettlements/${id}/approve`, data).then((axiosResponse) => {
    const response = axiosResponse?.data;
    if (response.data && response.data.name !== 'MongoError') {
      dispatch({ type: APPROVE_SETTLEMENTS_SUCCESS, payload: response.data });
      dispatch({ type: SHOW_MESSAGE, payload: `${data.is_approved ? 'Approved' : 'Dis-approved'} Settlement` });
    } else {
      dispatch({ type: APPROVE_SETTLEMENTS_ERROR, payload: response.data.name });
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: "Ops!, We're having trouble adding this" });
    }
  }).catch((error) => {
    dispatch({ type: APPROVE_SETTLEMENTS_ERROR, payload: error?.response?.data?.message || 'Error!' });
    dispatch({ type: SHOW_ERROR_MESSAGE, payload: error?.response?.data?.message || 'Error!' });
  });
};

export const downloadSettlements = (params, type) => (dispatch, getState) => {
  const { timezone } = getState().settings;
  dispatch({ type: DOWNLOAD_SETTLEMENTS_INIT });
  transactionsAxios.get(`/merchantSettlements?${params}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const currentPage = Number(axiosResponse.headers['content-range'].split('-')[0]);
    const totalRecords = Number(axiosResponse.headers['content-range'].split('/')[1]);
    const payload = {
      data: response.data.map((item) => {
        const momentDate = moment(item.created_at);
        const [month, day] = momentDate.format('MM DD').split(' ');
        return {
          created_month: month,
          created_day: day,
          ...item,
        };
      }),
      totalRecords,
      currentPage,
    };
    dispatch({ type: DOWNLOAD_SETTLEMENTS_SUCCESS, payload });
    const columns = [
      { title: 'Wallets', dataIndex: 'wallet' },
      { title: 'Transfer_amount', dataIndex: 'transfer_amount' },
      { title: 'Status', dataIndex: 'status' },
      { title: 'Approved', dataIndex: 'is_approved' },
      { title: 'Created at', dataIndex: 'created_at' },
      { title: 'Day', dataIndex: 'created_day' },
      { title: 'Month', dataIndex: 'created_month' },
      { title: 'Created by', dataIndex: 'created_by' },
    ];
    if (type === 'pdf') {
      downloadPDF(payload.data, columns, 'Settlements', timezone);
    } else {
      downloadExcel(payload.data, columns, 'Settlements', timezone);
    }
  }).catch((error) => {
    dispatch({ type: DOWNLOAD_SETTLEMENTS_ERROR, payload: error?.response?.data?.message || 'Error!' });
    dispatch({ type: SHOW_ERROR_MESSAGE, payload: error?.response?.data?.message || 'Error!' });
  });
};


export const getTransactions = (params = '') => (dispatch) => {
  dispatch({ type: FETCH_TRANSACTIONS_INIT });
  transactionsAxios.get(`${params ? `?${params}` : ''}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const headers = axiosResponse.headers['content-range'];
    let currentPage = 1;
    let totalRecords = 10;
    if (headers) {
      currentPage = Number(headers.split('-')[0]);
      totalRecords = Number(headers.split('/')[1]);
    }
    const payload = { data: response.data, currentPage, totalRecords };
    dispatch({ type: FETCH_TRANSACTIONS_SUCCESS, payload });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: FETCH_TRANSACTIONS_ERROR });
  });
};

export const downloadSummary = (params) => (dispatch) => {
  dispatch({ type: DOWNLOAD_SUMMARY_INIT });
  transactionsAxios.get(`reports/transactions/summary?${params}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const payload = { data: response.data };
    dispatch({ type: DOWNLOAD_SUMMARY_SUCCESS, payload });
    const summary = response.data;
    const data = [
      {
        type: 'refund',
        total_transaction_amount: summary.refund.total_transaction_amount,
        total_count: summary.refund.total_count,
      },
      {
        type: 'chargeback',
        total_count: summary.chargeback.total_count,
      },
      {
        type: 'failed',
        total_transaction_amount: summary.failed.total_transaction_amount,
        total_count: summary.failed.total_count,
      },
      {
        type: 'success',
        total_transaction_amount: summary.success.total_transaction_amount,
        total_count: summary.success.total_count,
      },
      {
        type: 'total',
        total_transaction_amount: summary.total.total_transaction_amount,
        total_count: summary.total.total_count,
      },
    ];
    downloadReport(data, 'Summary');
  }).catch((error) => {
    dispatch({ type: DOWNLOAD_SUMMARY_ERROR, payload: error?.response?.data?.message || 'Error!' });
    dispatch({ type: SHOW_ERROR_MESSAGE, payload: error?.response?.data?.message || 'Error!' });
  });
};

export const downloadTransactions = (params, type) => (dispatch, getState) => {
  const { timezone } = getState().settings;

  dispatch({ type: DOWNLOAD_TRANSACTIONS_INIT });
  transactionsAxios.get(`?${params}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const currentPage = Number(axiosResponse.headers['content-range'].split('-')[0]);
    const totalRecords = Number(axiosResponse.headers['content-range'].split('/')[1]);
    const payload = {
      data: response.data.map((item) => {
        const momentDate = moment(item.created_at);
        const [month, day] = momentDate.format('MM DD').split(' ');
        return {
          created_month: month,
          created_day: day,
          ...item,
        };
      }),
      totalRecords,
      currentPage,
    };
    dispatch({ type: DOWNLOAD_TRANSACTIONS_SUCCESS, payload });
    let columns = [
      { title: 'Date', dataIndex: 'created_at' },
      { title: 'Day', dataIndex: 'created_day' },
      { title: 'Month', dataIndex: 'created_month' },
      { title: 'Business Id', dataIndex: 'merchant' },
      { title: 'Business Name', dataIndex: 'business_name' },
      { title: 'P/R', dataIndex: 'kitegateway_reference' },
      { title: 'G/R', dataIndex: 'gateway_reference' },
      { title: 'M/R', dataIndex: 'merchant_reference' },
      { title: 'Type', dataIndex: 'transaction_type' },
      { title: 'Amount', dataIndex: 'transaction_amount' },
      { title: 'Currency', dataIndex: 'transaction_currency' },
      { title: 'Customer Name', dataIndex: 'customer_name' },
      { title: 'Customer Email', dataIndex: 'customer_email' },
      { title: 'Customer Phone', dataIndex: 'phone_number' },
      { title: 'Status', dataIndex: 'transaction_status' },
      { title: 'Processor Id', dataIndex: 'processor' },
      { title: 'Processor', dataIndex: 'processor_name' },
      { title: 'ARNs', dataIndex: 'refund_id' },
    ];
    if (type === 'pdf') {
      downloadPDF(payload.data, columns, 'Transactions', timezone);
    } else {
      downloadExcel(payload.data, columns, 'Transactions', timezone);
    }
  }).catch((error) => {
    dispatch({ type: DOWNLOAD_TRANSACTIONS_ERROR, payload: error?.response?.data?.message || 'Error!' });
    dispatch({ type: SHOW_ERROR_MESSAGE, payload: error?.response?.data?.message || 'Error!' });
  });
};

export const fetchTransactionSummary = (params = '', transactionType, transactionStatus) => (dispatch) => {
  dispatch({ type: FETCH_TRANSACTION_SUMMARY_INIT });
  transactionsAxios.get(`aggregated/transactions/summary${params ? `?${params}` : ''}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    switch (transactionStatus) {
      case TransactionStatuses.COMPLETED:
        dispatch({ type: FETCH_TRANSACTION_SUMMARY_VOLUME_SUCCESS, payload: response, transactionType, transactionStatus });
        break;
      case TransactionStatuses.FAILED:
        dispatch({ type: FETCH_TRANSACTION_SUMMARY_VOLUME_FAILED, payload: response, transactionType, transactionStatus });
        break;
      case "today":
        dispatch({ type: FETCH_TRANSACTION_SUMMARY_VOLUME_TODAY, payload: response, transactionType, transactionStatus });
        break;
      case "yesterday":
        dispatch({ type: FETCH_TRANSACTION_SUMMARY_VOLUME_YESTERDAY, payload: response, transactionType, transactionStatus });
        break;
      case "this_month":
        dispatch({ type: FETCH_TRANSACTION_SUMMARY_VOLUME_THIS_MONTH, payload: response, transactionType, transactionStatus });
        break;
      case "last_month":
        dispatch({ type: FETCH_TRANSACTION_SUMMARY_VOLUME_LAST_MONTH, payload: response, transactionType, transactionStatus });
        break;
      default:
        dispatch({ type: FETCH_TRANSACTION_SUMMARY_VOLUME_ALL, payload: response, transactionType, transactionStatus });
    }
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: FETCH_TRANSACTION_SUMMARY_ERROR });
    console.error(error);
  });
};
